define([],
    function () {

        var factorTwoForm = {
            borderless: true,
            view: "form",
            margin: 8,
            id: "factorTwoForm", elements: [{
                view: "text",
                align: "center",
                name: "code",
                label: APPLOCALE.authorize.code,
                labelWidth: 150,
                height: 38,
                width: 350,
                required: true
            }, {
                view: "button",
                label: APPLOCALE.button.btnSend,
                type: "form",
                align: "center",
                width: 120,
                height: 38,
                hotkey: "enter",
                click: function () {
                    var button = this;
                    this.disable();
                    var form = webix.$$("userAddForm");
                    var formFactorTwo = webix.$$("factorTwoForm");

                    if (form.validate()) {
                        var valuesFactorTwo = formFactorTwo.getValues();
                        var values = form.getValues();
                        webix.ajax().headers({
                            "Content-type": "application/json"
                        }).post(API_URL + "login-factor-two", {
                                login: values.username,
                                password: values.password,
                                code: valuesFactorTwo.code
                            }, {
                                error: function (text, data, XmlHttpRequest) {
                                    button.enable();
                                    try {
                                        var response = JSON.parse(text);
                                        if (response.errMsg)
                                            webix.message({
                                                type: "error",
                                                text: response.errMsg ? APPLOCALE.messages.msgError + response.errMsg : APPLOCALE.errors.errorLoadDataUnknown
                                            });

                                    } catch (e) {
                                        webix.message({
                                            type: "error",
                                            text: APPLOCALE.errors.errorLoadDataUnknown
                                        });
                                    }
                                },
                                success: function (text, data, XmlHttpRequest) {
                                    var redirectLocation = webix.storage.local.get("redirectUrlAfterAuth");
                                    if (redirectLocation) {
                                        webix.storage.local.remove("redirectUrlAfterAuth");
                                        window.location = redirectLocation.href;
                                    }
                                    window.location.reload();
                                }
                            }
                        );
                    } else {
                        this.enable();
                    }
                }
            }]
        };

        var factorTwoWindow = {
            view: "window",
            id: "factorTwoWindow",
            hidden: true,
            height: 250,
            width: 300,
            position: "center",
            head: {
                view: "toolbar",
                cols: [{
                    view: "label",
                    label: APPLOCALE.authorize.code,
                    align: "center"
                }, {
                    view: "button",
                    type: "danger",
                    label: 'X',
                    click: function () {
                        $$("factorTwoWindow").close();
                    },
                    width: 70
                }]
            },
            body: {
                paddingY: 30,
                paddingX: 30,
                view: "form",
                css: "toolbar",
                id: "addForm",
                elements: [factorTwoForm]
            }
        };

        var form = {
            elementsConfig: {
                width: 38
            },
            borderless: true,
            view: "form",
            margin: 8,
            id: "userAddForm", elements: [{
                view: "text",
                align: "center",
                name: "username",
                label: APPLOCALE.authorize.login,
                height: 38,
                width: 350,
                required: true
            }, {
                view: "text",
                align: "center",
                type: "password",
                name: "password",
                height: 38,
                label: APPLOCALE.authorize.password,
                width: 350,
                required: true
            }, {
                view: "button",
                label: APPLOCALE.button.btnEnter,
                type: "form",
                align: "center",
                width: 120,
                height: 38,
                hotkey: "enter",
                click: function () {
                    var button = this;
                    this.disable();
                    var form = webix.$$("userAddForm");

                    if (form.validate()) {
                        var values = form.getValues();
                        values.username = values.username.trim();
                        form.setValues(values);

                        webix.ajax().headers({
                            "Content-type": "application/json"
                        }).post(API_URL + "login", {
                                login: values.username,
                                password: values.password,
                            }, {
                                error: function (text, data, XmlHttpRequest) {
                                    button.enable();
                                    try {
                                        var response = JSON.parse(text);
                                        if (response.errMsg)
                                            webix.message({
                                                type: "error",
                                                text: response.errMsg ? APPLOCALE.messages.msgUserNotFound : APPLOCALE.errors.errorLoadDataUnknown
                                            });

                                    } catch (e) {
                                        webix.message({
                                            type: "error",
                                            text: APPLOCALE.errors.errorLoadDataUnknown
                                        });
                                    }
                                },
                                success: function (text, data, XmlHttpRequest) {
                                    var redirectLocation;
                                    if (JSON.parse(text).data.is_two_fa) {
                                        button.enable();
                                        webix.ui(factorTwoWindow).show();
                                    } else {
                                        redirectLocation = webix.storage.local.get("redirectUrlAfterAuth");
                                        if (redirectLocation) {
                                            webix.storage.local.remove("redirectUrlAfterAuth");
                                            window.location = redirectLocation.href;
                                        }
                                        window.location.reload();
                                    }
                                }
                            }
                        );
                    } else {
                        this.enable();
                    }
                }
            }]
        };

        var flex = {
            rows: [{
                height: 49,
                id: "title",
                css: "title",
                template: "<div class='header'>#title#</div><div class='details'>#details#</div>",
                data: {title: APPLOCALE.authorize.details, details: APPLOCALE.authorize.title}
            },
                {},
                form,
                {}]
        };

        var errorMessageAtLoginPage = webix.storage.local.get("errorMessageAtLoginPage");
        if (errorMessageAtLoginPage) {
            webix.message({
                type: "error",
                text: errorMessageAtLoginPage
            });
            webix.storage.local.remove("errorMessageAtLoginPage");
        }

        return {
            $ui: flex
        };
    }
);